import { Component, inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ChangelogItem } from '@evorait/pace-components';

@Component({
    selector: 'pace-core-changelog',
    templateUrl: './changelog.component.html',
    styleUrl: './changelog.component.css',
})
export class ChangelogComponent {
    private readonly translate = inject(TranslateService);
    public readonly modalInstance: BsModalRef = inject(BsModalRef);

    @Input()
    public changelogs: ChangelogItem[] = [];

    public readonly changelogConfig = {
        headlines: {
            ADDED: this.translate.instant('CHANGELOG_ENTRY_TYPE.ADDED'),
            FIXED: this.translate.instant('CHANGELOG_ENTRY_TYPE.FIXED'),
            REMOVED: this.translate.instant('CHANGELOG_ENTRY_TYPE.REMOVED'),
        },
        summary: this.translate.instant('CHANGELOG_INTRO'),
    };
}
